import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { QueueCounterData } from './queue-counter.model';

@Injectable({
    providedIn: 'root'
})
export class QueueCounterService {

    constructor(
        private cvApiService: CVApiService,
    ) { }

    public async loadQueueCounterData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
        try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const url = `/api/v2/dashboards/modules/queueCounter/${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            const response = await this.cvApiService.get<QueueCounterData>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed getting data for Queue Counter Module.");
            throw err;
        }
    };
}
